<form [formGroup]="formTipoEstablecimiento" class="mr-5 ml-5 mt-5 mb-3" (ngSubmit)="goPaso()">
  <section class="row">
    <!-- SECCION CAMPO ADICIONAL (IZQUIERDA) -->
    <section class="col-sm-12 col-md-6 pr-5">
      <header class="row form-group d-flex align-items-center">
        <figure class="m-auto">
          <img src="../../../../../../../../assets/icons/info-establecimiento.png"
            class="d-inline-block p-2 rounded-circle" alt="" height="60">
        </figure>
        <div class="col">
          <h2 class="col-12 h5 mb-0 pl-0">Requisitos</h2>
        </div>
      </header>

      <section>
        <div class="form-row">

          <!-- PREGUNTAS CAMPO ADICIONAL V2 -->
          <div id="containerPreguntasCampoAdicional" style="margin-top: 0 !important;" class="w-100 mt-5">
          </div>

          <!-- No data found -->
          <div *ngIf="!camposAdicionales || camposAdicionales.length <= 0" class="col-sm-12 col form-group">
            <label class="text-muted">No hay informacion</label>
          </div>

        </div>
      </section>

      <div class="form-row">
        <div
          *ngIf="buscarCampoAdicional(CamposAdicionalesEnum.RelacionarVehiculos) && formTipoEstablecimiento.get(campos_vehiculo.desc_campo_adicional)"
          class="w-75 form-group">
          <button type="button" class="btn btn-primary paso-tipo-establecimiento-btn-inicio"
            (click)="onOpenModalVehiculos()">
            {{campos_vehiculo.titulo}}
          </button>
        </div>
        <div
          *ngIf="buscarCampoAdicional(CamposAdicionalesEnum.EsTurismoAventura) && formTipoEstablecimiento.get(campos_es_turismo_aventura.desc_campo_adicional)"
          class="w-75 form-group">
          <header>
            <label class="h5">Turismo Aventura</label>
          </header>
          <footer>
            <label for="{{campos_es_turismo_aventura.desc_campo_adicional}}"
              class="text-muted form-check-label">{{campos_es_turismo_aventura.titulo}}</label>
            <div class="row mt-3">
              <div class="form-group d-flex col-6">
                <!-- <input id="{{campos_es_turismo_aventura.desc_campo_adicional}}" type="checkbox" class="form-check mt-1"
             formControlName="{{campos_es_turismo_aventura.desc_campo_adicional}}" (change)="onCheckTurismo()" />
            <label for="{{campos_es_turismo_aventura.desc_campo_adicional}}" class="text-muted form-check-label ml-3">{{campos_es_turismo_aventura.titulo}}</label> -->
                <input id="{{campos_es_turismo_aventura.desc_campo_adicional}}_s" class="form-check mt-1" type="radio"
                  formControlName="{{campos_es_turismo_aventura.desc_campo_adicional}}" (change)="onCheckTurismo()"
                  [value]="true" attr.name="{{campos_es_turismo_aventura.desc_campo_adicional}}" attr.value="true" />
                <label for="{{campos_es_turismo_aventura.desc_campo_adicional}}_s"
                  class="text-muted form-check-label ml-3">Si</label>
              </div>
              <div class="form-group d-flex col-6">
                <input id="{{campos_es_turismo_aventura.desc_campo_adicional}}_n" class="form-check mt-1" type="radio"
                  formControlName="{{campos_es_turismo_aventura.desc_campo_adicional}}" (change)="onCheckTurismo()"
                  [value]="false" attr.name="{{campos_es_turismo_aventura.desc_campo_adicional}}" attr.value="false" />
                <label for="{{campos_es_turismo_aventura.desc_campo_adicional}}_n"
                  class="text-muted form-check-label ml-3">No</label>
              </div>
            </div>
          </footer>
        </div>
        <ng-container
          *ngIf="buscarCampoAdicional(CamposAdicionalesEnum.EsTurismoAventura) && formTipoEstablecimiento.get(campos_es_turismo_aventura.desc_campo_adicional) && formTipoEstablecimiento.value[campos_es_turismo_aventura.desc_campo_adicional]">
          <section class="col-12 seccion-turismo">
            <ng-container *ngFor="let item of listaTurismoAventura">
              <div class="col-12 form-check-inline justify-content-between pr-3 pl-3 pt-2 pb-2 rounded bg-gray mb-3">
                <label class="small text-secondary mb-0">{{item.descripcion}}</label>
                <input type="checkbox" class="form-check" (change)="onLinkDocumento($event, item)"
                  [checked]="item.seleccionado" />
              </div>
            </ng-container>
          </section>
        </ng-container>

        <div
          *ngIf="buscarCampoAdicional(CamposAdicionalesEnum.AplicaPropiedadHorizontal) && formTipoEstablecimiento.get(campos_aplica_propiedad_horizontal.desc_campo_adicional)"
          class="w-75 form-group">
          <header>
            <label class="h5">Propiedad Horizontal</label>
          </header>
          <footer>
            <!-- <div class="form-group d-flex">
          <input id="{{campos_aplica_propiedad_horizontal.desc_campo_adicional}}" type="checkbox"
            class="form-check mt-1" formControlName="{{campos_aplica_propiedad_horizontal.desc_campo_adicional}}"
            (change)="onCheckPropiedadHorizontal()" />
          <label for="{{campos_aplica_propiedad_horizontal.desc_campo_adicional}}"
            class="text-muted form-check-label ml-3">{{campos_aplica_propiedad_horizontal.titulo}}</label>
        </div> -->
            <label for="{{campos_aplica_propiedad_horizontal.desc_campo_adicional}}"
              class="text-muted form-check-label">{{campos_aplica_propiedad_horizontal.titulo}}</label>
            <div class="row mt-3">
              <div class="form-group d-flex col-6">
                <input id="{{campos_aplica_propiedad_horizontal.desc_campo_adicional}}_sh" class="form-check mt-1"
                  type="radio" formControlName="{{campos_aplica_propiedad_horizontal.desc_campo_adicional}}"
                  (change)="onCheckPropiedadHorizontal()" [value]="true"
                  attr.name="{{campos_aplica_propiedad_horizontal.desc_campo_adicional}}" attr.value="true" />
                <label for="{{campos_aplica_propiedad_horizontal.desc_campo_adicional}}_sh"
                  class="text-muted form-check-label ml-3">Si</label>
              </div>
              <div class="form-group d-flex col-6">
                <input id="{{campos_aplica_propiedad_horizontal.desc_campo_adicional}}_nh" class="form-check mt-1"
                  type="radio" formControlName="{{campos_aplica_propiedad_horizontal.desc_campo_adicional}}"
                  (change)="onCheckPropiedadHorizontal()" [value]="false"
                  attr.name="{{campos_aplica_propiedad_horizontal.desc_campo_adicional}}" attr.value="false" />
                <label for="{{campos_aplica_propiedad_horizontal.desc_campo_adicional}}_nh"
                  class="text-muted form-check-label ml-3">No</label>
              </div>
            </div>
          </footer>
          <ng-container *ngIf="buscarCampoAdicional(CamposAdicionalesEnum.AplicaPropiedadHorizontal) && formTipoEstablecimiento.get(campos_aplica_propiedad_horizontal.desc_campo_adicional)
&& formTipoEstablecimiento.value[campos_aplica_propiedad_horizontal.desc_campo_adicional]">
            <footer>
              <label for="{{campos_es_turismo_aventura.desc_campo_adicional}}"
                class="text-muted form-check-label">{{campos_tieneautoriza_propiedad_horizontal.titulo}}</label>
              <div class="row mt-3">
                <div class="form-group d-flex col-6">
                  <input id="{{campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional}}_sa"
                    class="form-check mt-1" type="radio"
                    formControlName="{{campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional}}"
                    (change)="onCampoAdicionalCheck(campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional)"
                    [value]="true" attr.name="{{campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional}}"
                    attr.value="true" />
                  <label for="{{campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional}}_sa"
                    class="text-muted form-check-label ml-3">Si</label>
                </div>
                <div class="form-group d-flex col-6">
                  <input id="{{campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional}}_na"
                    class="form-check mt-1" type="radio"
                    formControlName="{{campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional}}"
                    (change)="onCampoAdicionalCheck(campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional)"
                    [value]="false" attr.name="{{campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional}}"
                    attr.value="false" />
                  <label for="{{campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional}}_na"
                    class="text-muted form-check-label ml-3">No</label>
                </div>
              </div>
            </footer>
          </ng-container>
        </div>
      </div>
      <p *ngIf="tieneAutorizaPropiedadHorizontalCtrl?.hasError('mustMatchField')"
        class="error-message small text-danger my-1 font-weight-bold">La respuestas anteriores deben coincidir.</p>
    </section>

    <!-- SECCION DOCUMENTOS (DERECHA) -->
    <section class="col-sm-12 col-md-6 pl-5">
      <app-ayudas [ayuda]="ayudaService.datosAdicionales(
          datoSolicitudSharedModel.tipo_solicitud, 
          datoSolicitudSharedModel.tipo_rnt, 
          rnt.sub_categoria_id, 
          rnt.estado_rnt_id,
          rnt.estado_solicitud_id
          )">
      </app-ayudas>

      <header class="row">
        <div *ngIf="isCategoria; else mostraM">
          <p class="col-12 small p-0 mb-2">Señale si cumplen <b>con al menos tres (3)</b> de las siguientes
            características:</p>
        </div>

        <ng-template #mostraM>
          <p class="col-12 small p-0 mb-2">Seleccione los requisitos con los que cuenta</p>
        </ng-template>
      </header>

      <section class="row">
        <div *ngIf="(!listadoPreguntas || listadoPreguntas.length <= 0)" class="col-sm-12 col form-group mt-4">
          <label class="text-muted">No hay informacion</label>
        </div>

        <!-- PREGUNTAS DOCUMENTOS V2 -->
        <div id="containerPreguntasDocumento" class="w-100 mt-5">
        </div>
      </section>
    </section>
  </section>

  <footer class="text-right p-3">
    <button type="button" class="btn btn-outline-primary paso-capacidad-info-btn-inicio mr-2 pl-4 pr-4"
      (click)="onRegresarPaso()">Atras</button>

    <button type="submit" class="btn btn-primary paso-tipo-establecimiento-btn-inicio"
      [disabled]="isDisabled || (tieneAutorizaPropiedadHorizontalCtrl && tieneAutorizaPropiedadHorizontalCtrl.invalid)">Siguiente</button>
  </footer>
</form>